import Swiper from 'swiper';
import { Pagination, Autoplay, EffectFade } from 'swiper';
import {spanWrapText} from './libs.js';
import gsap from "gsap";

const setMvSlider = () => {
  const heroHeadline = document.querySelectorAll('.hero-headline');
  const heroBtnText = document.querySelectorAll('.hero-btn .btn-text');
  spanWrapText(heroHeadline);
  spanWrapText(heroBtnText);

  const slides = document.querySelectorAll(".js-hero-slider .swiper-slide");
  const slidesLength = slides.length;


  if (slidesLength > 1) {
    const slider = document.querySelector(".js-hero-slider");
    let first = false;
    let swiperDelay = 10000;
    let swiperSpeed = 3000;

    function setBullet(bullets) {
      let totalDuration = 0;
      slides.forEach((el, index) => {
        const video = el.querySelector('video');
        const bullet = bullets[index];

          if(video) {
            el.setAttribute('data-duration', video.duration)
            bullet.setAttribute('data-duration', video.duration)
            totalDuration += Number(video.duration);
          } else {
            el.setAttribute('data-duration', swiperDelay / 1000)
            bullet.setAttribute('data-duration', swiperDelay / 1000)
            totalDuration += Number(swiperDelay / 1000);
          }
        })

        bullets.forEach((el, index) => {
          const duration = el.getAttribute('data-duration');
          const bulletWidth = duration / totalDuration * 100;
          el.style.width = bulletWidth + '%';
          el.style.animationDuration = duration + 's';

          if(el.classList.contains('swiper-pagination-bullet-active')) {
            el.style.width = (bulletWidth * 2) + '%';
          }
      })
    }

    var swiper = new Swiper(slider, {
      modules: [Pagination, Autoplay, EffectFade],
      autoplay: {
        delay: swiperDelay,
        disableOnInteraction: false,
      },
      speed: swiperSpeed,
      loop: true,
      effect:'fade',
      fadeEffect: {
        crossFade: true
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      allowTouchMove: false,
      on: {
        slideChange: function () {
          const swiper = this;
          const activeIndex = swiper.activeIndex;
          const activeSlide = swiper.slides[activeIndex];
          const video = activeSlide.querySelector('video');
          const heroTitleChar = activeSlide.querySelectorAll('.hero__title .char');
          const heroSubtitleChar = activeSlide.querySelectorAll('.hero__subtitle .char');
          const heroBtn = activeSlide.querySelector('.hero-btn');
          const heroBtnBg = heroBtn.querySelector('.btn-bg');
          const heroBtnTextChar = heroBtn.querySelectorAll('.btn-text .char');
          const heroBtnArrow = heroBtn.querySelector('.arrow');

          if(swiper.pagination.bullets.length) {
            setBullet(this.pagination.bullets)
          }

          if(!first) {
            if (video) {
              video.currentTime = 0;
              video.play();
              swiper.params.autoplay.delay = video.duration * 1000;
            } else {
              swiper.params.autoplay.delay = swiperDelay;
            }
          } else {
            if (video) {
              video.currentTime = 0;
              video.play();
              swiper.params.autoplay.delay = video.duration * 1000 - swiperSpeed;
            } else {
              swiper.params.autoplay.delay = swiperDelay - swiperSpeed;
            }
          }

          gsap.set([heroTitleChar, heroSubtitleChar], {
            display: 'inline-block',
            opacity: 0,
            x: 30,
            color: '#000',
          })

          gsap.set(heroBtn, {
            clipPath: 'polygon(0 0, 100% 0, 100% 100%, 0 100%)',
          })

          gsap.set(heroBtnBg, {
            clipPath: 'polygon(0 0, 0 0, 0 100%, 0 100%)',
          })

          gsap.set(heroBtnTextChar, {
            display: 'inline-block',
            opacity: 0,
          })

          gsap.set(heroBtnArrow, {
            opacity: 0,
            x: -20,
          })

          const textAnim = gsap.timeline({delay: .4})
            .to(heroTitleChar, {
              opacity: 1,
              x: 0,
              duration: 1.2,
              ease: 'expo.out',
              stagger: {
                each: 0.05,
              }
            })
            .to(heroTitleChar, {
              color: '#fff',
              duration: 2,
              ease: 'expo.out',
              stagger: {
                each: 0.05,
              }
            }, '<')
            .to(heroSubtitleChar, {
              opacity: 1,
              x: 0,
              duration: 1.2,
              ease: 'expo.out',
              stagger: {
                each: 0.05,
              }
            }, '<')
            .to(heroSubtitleChar, {
              color: '#fff',
              duration: 2,
              ease: 'expo.out',
              stagger: {
                each: 0.05,
              }
            }, '<')

          const btnAnim = gsap.timeline({delay: .4})
            .to(heroBtnBg, {
              clipPath: 'polygon(0 0, 100% 0, 100% 100%, 0 100%)',
              duration: .6,
              ease: 'expo.inOut'
            })
            .to(heroBtnTextChar, {
              opacity: 1,
              x: 0,
              duration: 1.2,
              ease: 'expo.out',
              stagger: {
                each: 0.05,
              }
            }, '<+=.4')
            .to(heroBtnArrow, {
              opacity: 1,
              duration: .6,
              ease: 'sine.inOut',
            }, '<+=.4')
            .to(heroBtnArrow, {
              x: 0,
              duration: 0,
            }, '<')
        },
        afterInit : function () {
          first = true;
          setBullet(this.pagination.bullets)
        },
        beforeSlideChangeStart() {
          const activeIndex = this.activeIndex;
          const activeSlide = this.slides[activeIndex];
          const heroTitleChar = activeSlide.querySelectorAll('.hero__title .char');
          const heroSubtitleChar = activeSlide.querySelectorAll('.hero__subtitle .char');
          const heroBtn = activeSlide.querySelector('.hero-btn');

          gsap.timeline()
            .to(heroTitleChar, {
              opacity: 0,
              // x: -40,
              duration: 1,
              ease: 'expo.out',
              // stagger: {
              //   each: 0.05,
              // }
            })
            .to(heroSubtitleChar, {
              opacity: 0,
              // x: -40,
              duration: 1,
              ease: 'expo.out',
              // stagger: {
              //   each: 0.05,
              // }
            }, '<')

          gsap.to(heroBtn, {
            clipPath: 'polygon(100% 0, 100% 0, 100% 100%, 100% 100%)',
            duration: .6,
            ease: 'expo.inOut'
          })
        },
        resize: function() {
          this.autoplay.start();
        }
      },
    });
  } else {
    // $(".js-hero-slider").addClass("slideNone");
  }
}

export default setMvSlider;